import React from 'react';
import PropTypes from 'prop-types';

import {
    AccordionBasicItem,
    ACCORDION_VARIANTS,
    ACCORDION_MARKER_VARIANTS,
    ACCORDION_HEADER_SIZES,
    ACCORDION_HEADER_WEIGHTS,
    ACCORDION_BACKGROUND_COLOURS,
    IconMapLazy,
    MessagePropType,
} from '@ratehub/base-ui';


const WORDPRESS_EMPTY_CONTENT = '\n<div></div>\n';

function AccordionItem({
    content,
    title,
    marker = ACCORDION_MARKER_VARIANTS.NONE,
    iconKey,
    number,
    isInitiallyExpanded = false,
    variant = ACCORDION_VARIANTS.DEFAULT,
    size = ACCORDION_HEADER_SIZES.LARGE,
    weight = ACCORDION_HEADER_WEIGHTS.REGULAR,
    accordionBackgroundColour = ACCORDION_BACKGROUND_COLOURS.TRANSPARENT,
    children,
    ...otherProps
}) {
    return (
        <AccordionBasicItem
            title={title}
            marker={marker}
            iconKey={iconKey}
            number={number}
            isInitiallyExpanded={isInitiallyExpanded}
            variant={variant}
            size={size}
            weight={weight}
            backgroundColour={accordionBackgroundColour}
            {...otherProps}
        >
            {/* Deprecated - This is to support existing use cases where we only allowed a single rich text field
                Using an IF block here because content gets set to an empty DIV with inconsistent white space */}
            <If condition={content && content !== WORDPRESS_EMPTY_CONTENT}>
                <div
                    className="rich-text"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                        __html: content,
                    }}
                />
            </If>
            {/* END Deprecated */}

            {children}
        </AccordionBasicItem>
    );
}

AccordionItem.propTypes = {
    content: PropTypes.string, // Deprecated - see note above
    title: MessagePropType.isRequired,
    marker: PropTypes.oneOf(Object.values(ACCORDION_MARKER_VARIANTS)),
    iconKey: PropTypes.oneOf(Object.keys(IconMapLazy)),
    number: PropTypes.number,
    isInitiallyExpanded: PropTypes.bool,
    variant: PropTypes.oneOf(Object.values(ACCORDION_VARIANTS)),
    size: PropTypes.oneOf(Object.values(ACCORDION_HEADER_SIZES)),
    weight: PropTypes.oneOf(Object.values(ACCORDION_HEADER_WEIGHTS)),
    accordionBackgroundColour: PropTypes.oneOf(Object.values(ACCORDION_BACKGROUND_COLOURS)),
    children: PropTypes.any,
};

AccordionItem.blockKey = 'rh/accordion-item';

export default AccordionItem;
